import React from 'react';
import Paper from "@material-ui/core/Paper";
import {withStyles} from "@material-ui/styles";
import {NotificationManager, NotificationContainer} from "react-notifications";
import TableComponent from "../common/TableComponent";
import {AddCircleOutlineTwoTone, AddCircleTwoTone, SystemUpdateAltTwoTone} from "@material-ui/icons";

import TextField from "@material-ui/core/TextField";
import moment from "moment";
import {BlueButton, GreenButton, OrangeButton, RedButton} from "../common/ButtonsConstants";
import {
    imsImprovementRegister,
    imsImprovementRegisterRevision,
    deleteImsImprovementRegister,
    saveOrUpdateImsImprovementRegister,
    addImsImprovementRegisterRevision,
} from "../../util/OperationModuleApiUtils";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import Modal from "@material-ui/core/Modal";
import Typography from "@material-ui/core/Typography";
import {Spinner} from "../common/Spinner";
import {exportReport} from "../../util/ApiUtils";
import CommonRevisionModal from "../common/CommonRevisionModal";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import * as CommonUtils from "../../util/CommonUtils";

const classes = (() => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
}));

const columns = [
    {
        name: 'Improvement Number',
        id: 'improvementNumber',
        type: "text",
    },
    {
        name: 'Date Opened',
        id: 'displayDateOpened',
        type: "text",
    },
    {
        name: 'Description of the Improvement Initiative',
        id: 'description',
        type: "text",
    },
    {
        name: 'Status',
        id: 'status',
        type: "text",
    },
    {
        name: 'Date closed on the Improvement Register',
        id: 'displayDateClosed',
        type: "text",
    },
];

class ImsImprovementRegister extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            imsImprovementRegister: [],
            latestRevision: {},
            isLoading: true,
            isEditing: false,
            show: false,
            dateOpened: null,
            improvementNumber: "",
            displayDateOpened: "",
            description: "",
            status: "",
            displayDateClosed: "",
            dateClosed: null,
            header: "",
        };
        this.loadImsImprovementRegister = this.loadImsImprovementRegister.bind(this);
        this.loadImsImprovementRegisterRevision = this.loadImsImprovementRegisterRevision.bind(this);
        this.handleAddRow = this.handleAddRow.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.handleTextChange = this.handleTextChange.bind(this);
        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onEdit = this.onEdit.bind(this);
        this.addRevision = this.addRevision.bind(this);
        this.onDateOpenedChange = this.onDateOpenedChange.bind(this);
        this.onDateClosedChange = this.onDateClosedChange.bind(this);
    }

    showModal() {
        this.setState({
            show: true
        });
    }

    onDateOpenedChange(event, date) {
        this.setState({
            ...this.state, dateOpened: moment(date, "DD/MM/YYYY"),
        });
    }

    onDateClosedChange(event, date) {
        this.setState({
            ...this.state, dateClosed: moment(date, "DD/MM/YYYY"),
        });
    }

    closeModal(updatedRevision) {
        console.log("updatedRevision");
        console.log(updatedRevision);
        if (updatedRevision) {
            this.setState({
                show: false,
                latestRevision: updatedRevision,
            });
        } else {
            this.setState({
                show: false,
            });
        }
    }

    componentDidMount() {
        this.loadImsImprovementRegister();
        this.loadImsImprovementRegisterRevision();
    }

    addRevision(request) {
        addImsImprovementRegisterRevision(request)
            .then(response => {
                NotificationManager.success('Success', 'The Revision has been updated.', 5000);
                console.log('response');
                console.log(response);
                this.closeModal(response);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    loadImsImprovementRegisterRevision() {
        imsImprovementRegisterRevision()
            .then(response => {
                console.log('ims improvement register revision', response);
                this.setState({
                    latestRevision: response,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    loadImsImprovementRegister() {
        imsImprovementRegister()
            .then(response => {
                console.log('ImsImprovementRegisterResponse', response);
                this.setState({
                    imsImprovementRegister: response,
                    isLoading: false,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    onEdit(row) {
        this.setState({
            isEditing: true,
            isLoading: false,
            isNew: false,
            id: row.id,
            header: `${row.improvementNumber}`,
            dateOpened: row.dateOpened,
            improvementNumber: row.improvementNumber,
            displayDateOpened: row.displayDateOpened,
            description: row.description,
            status: row.status,
            displayDateClosed: row.displayDateClosed,
            dateClosed: row.dateClosed,
        });
    }

    handleAddRow() {
        this.setState({
            isEditing: true,
            isLoading: false,
            isNew: true,
            dateOpened: null,
            improvementNumber: "",
            displayDateOpened: "",
            description: "",
            status: "",
            displayDateClosed: "",
            dateClosed: null,
            header: "New Record",
        })
    }

    reset() {
        this.setState({
            isEditing: false,
            isLoading: true,
            isNew: true,
            dateOpened: null,
            improvementNumber: "",
            displayDateOpened: "",
            description: "",
            status: "",
            displayDateClosed: "",
            dateClosed: null,
            header: "New Record",
        });
        this.loadImsImprovementRegister();
    }

    onCancel() {
        this.reset();
    }

    onDelete(record) {
        console.log(record);
        deleteImsImprovementRegister(record)
            .then(() => {
                console.log("removed id " + record.id);
                console.log("removed " + record);
                console.log(this.state);
                NotificationManager.success('Success', 'The Ims Improvement Register record has been removed.', 5000);
                this.reset();
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    onSave(event) {
        event.preventDefault();
        saveOrUpdateImsImprovementRegister(this.state)
        .then((updatedRecord) => {
            NotificationManager.success('Success', 'The Ims Improvement Register record has been updated.', 5000);
            this.reset();
        }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    handleTextChange({ target }) {
        this.setState({
            ...this.state, [target.name]: target.value
        });
    }

    render() {
        let { state } = this;
        let { classes } = this.props;
        if (state.isLoading) {
            return <Spinner/>;
        }

        const isRevision = (state.latestRevision.id !== null);
        let isDemo = this.props.currentUser && this.props.currentUser.isDemo;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        return <div>
            <Typography component="h2" variant="h5">
                IMS IMPROVEMENT REGISTER
            </Typography>
            <Paper className={classes.root} style={{ marginTop: '30px' }}>
                <Card className={classes.card}>
                    {(!state.isEditing ?
                            <CardHeader
                                action={
                                    <BlueButton
                                        variant="contained"
                                        color="secondary"
                                        startIcon={<AddCircleOutlineTwoTone/>}
                                        onClick={this.showModal}
                                        size="small"
                                        style={{marginRight: '10px'}}
                                        disabled={isAuditor}
                                    >
                                        ADD
                                    </BlueButton>
                                }
                                title={
                                    <span style={{color: "darkblue"}}>
                                        <p><b>{isRevision && `Revision ${state.latestRevision.number} Author: ${state.latestRevision.author}`}</b></p>
                                        <p><b>Approved for suitability and adequacy by: {state.latestRevision.approvedBy} on {moment(state.latestRevision.date).format('DD/MM/YYYY')}</b></p>
                                    </span>
                                }
                            />
                            :
                            <CardHeader
                                style={{ paddingBottom: "0px", paddingLeft: "46px" }}
                                title={
                                    <span style={{color: "darkblue"}}>
                                    <p><b>{state.header}</b></p>
                                </span>
                                }
                            />
                    )}
                    <CardContent>
                        {(!state.isEditing ?
                                <div>
                                    {!isDemo && <GreenButton startIcon={<SystemUpdateAltTwoTone/>} onClick={() => exportReport('/ims-improvement-register/export')} style={{ float: 'right', marginRight: "160px" }}>EXPORT</GreenButton>}
                                    <TableComponent
                                        tableKey="imsImprovementRegisterTable"
                                        data={state.imsImprovementRegister}
                                        columns={columns}
                                        handleSubmit={this.handleSubmit}
                                        handleAddRow={this.handleAddRow}
                                        handleRowDel={this.onDelete}
                                        handleRowEdit={this.onEdit}
                                        allowAdd={isRevision && !isAuditor ? 'show' : 'disable'}
                                        pagination={true}
                                        allowUpdateDelete={isAuditor ? 'no' : 'yes'}
                                    />
                                </div>
                                :
                                <div style={{ paddingLeft: "30px", paddingRight: "30px",  paddingBottom: "30px"}}>
                                    { !state.isNew && <div style={{ paddingTop: "20px"}}>
                                        <label>Improvement Number:</label> <span>{state.improvementNumber}</span>
                                    </div> }
                                    <div style={{ paddingTop: "20px" }}>
                                        <MuiPickersUtilsProvider utils={MomentUtils}>
                                            <KeyboardDatePicker
                                                disableToolbar
                                                autoOk
                                                variant="inline"
                                                format="DD/MM/YYYY"
                                                margin="normal"
                                                id="dateOpened"
                                                label="Date opened"
                                                name="dateOpened"
                                                value={state.dateOpened}
                                                onChange={ this.onDateOpenedChange }
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                style={{ width: "400px"}}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </div>
                                    <div style={{ paddingTop: "20px"}}>
                                        <TextField
                                            id="description"
                                            name="description"
                                            value={state.description}
                                            label="Description of the Improvement Initiative"
                                            onChange={this.handleTextChange}
                                            style={{ width: "600px"}}
                                        />
                                    </div>
                                    <div style={{ paddingTop: "20px"}}>
                                        <FormControl className={classes.formControl} style={{ width: '600px'}}>
                                            <InputLabel id="status-label">Status ie OPEN/CLOSED/CANCELLED</InputLabel>
                                            <Select
                                                labelId="status-label"
                                                id="status-id"
                                                value={this.state.status }
                                                name="status"
                                                onChange={this.handleTextChange}
                                            >
                                                <MenuItem value="OPEN">OPEN</MenuItem>
                                                <MenuItem value="CLOSED">CLOSED</MenuItem>
                                                <MenuItem value="CANCELLED">CANCELLED</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div style={{ paddingTop: "20px" }}>
                                        <MuiPickersUtilsProvider utils={MomentUtils}>
                                            <KeyboardDatePicker
                                                disableToolbar
                                                autoOk
                                                variant="inline"
                                                format="DD/MM/YYYY"
                                                margin="normal"
                                                id="dateClosed"
                                                label="Date closed on the Improvement Register"
                                                name="dateClosed"
                                                value={state.dateClosed}
                                                onChange={ this.onDateClosedChange }
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                style={{ width: "400px"}}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </div>
                                    <div style={{ width: "800px", clear: "both", paddingTop: "30px" }}>
                                        <OrangeButton
                                            variant="contained"
                                            color="secondary"
                                            startIcon={<AddCircleTwoTone />}
                                            size="small"
                                            onClick={this.onCancel}
                                            style={{ marginTop: '20px', marginBottom: '20px', marginRight: '20px' , float: "left" }}
                                        >
                                            CANCEL
                                        </OrangeButton>
                                        <GreenButton
                                            variant="contained"
                                            color="secondary"
                                            startIcon={<AddCircleTwoTone />}
                                            size="small"
                                            onClick={this.onSave}
                                            style={{ marginTop: '20px', marginBottom: '20px', float: "left" }}
                                        >
                                            SAVE
                                        </GreenButton>
                                    </div>
                                </div>
                        )}
                    </CardContent>
                </Card>
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={state.show}
                    onClose={() => this.closeModal(null)}
                >
                    <CommonRevisionModal latestRevisionDto={state.latestRevision} addRevision={this.addRevision}/>
                </Modal>
            </Paper>
            <NotificationContainer/>
        </div>
    }
}

export default withStyles(classes)(ImsImprovementRegister);
